import { type FunctionComponent } from "react";
import {
  Activity,
  AlarmClock,
  Apple,
  Ban,
  Bike,
  BookOpen,
  Brain,
  Carrot,
  CircleCheck,
  Coffee,
  Dumbbell,
  Droplet,
  Flame,
  Footprints,
  GlassWater,
  Heart,
  HeartPulse,
  Leaf,
  type LucideIcon,
  Moon,
  Pencil,
  Pill,
  Salad,
  Smartphone,
  Smile,
  Sparkles,
  Sun,
  Target,
  Utensils,
  Waves,
} from "lucide-react";

import { type HabitIconKey, resolveHabitIconKey } from "@fitness-app/data-models/domain/habitIcons";

// TRE-1584 — admin-side map of the canonical habit icon keys to lucide-react components.
export const habitIconComponents: Record<HabitIconKey, LucideIcon> = {
  "circle-check": CircleCheck,
  droplet: Droplet,
  "glass-water": GlassWater,
  dumbbell: Dumbbell,
  footprints: Footprints,
  bike: Bike,
  waves: Waves,
  activity: Activity,
  heart: Heart,
  "heart-pulse": HeartPulse,
  brain: Brain,
  "book-open": BookOpen,
  pencil: Pencil,
  moon: Moon,
  sun: Sun,
  "alarm-clock": AlarmClock,
  apple: Apple,
  salad: Salad,
  carrot: Carrot,
  pill: Pill,
  utensils: Utensils,
  coffee: Coffee,
  smile: Smile,
  sparkles: Sparkles,
  flame: Flame,
  target: Target,
  leaf: Leaf,
  ban: Ban,
  smartphone: Smartphone,
};

/** Renders a habit's icon (accepts a lucide key or a legacy emoji, both resolved to a key). */
export const HabitIcon: FunctionComponent<{ iconKey: string | null | undefined; size?: number; color?: string }> = ({
  iconKey,
  size = 16,
  color,
}) => {
  const Icon = habitIconComponents[resolveHabitIconKey(iconKey)] ?? CircleCheck;
  return <Icon size={size} color={color} />;
};
